export default {
  baseURL: process.env.VUE_APP_BASE_URL || '/v1',
  fileServer: process.env.VUE_APP_FILE_SERVER || '/files',
  defaultSKYPlayService:
    process.env.VUE_APP_SKYPLAY_SERVICE || '127.0.0.1:50051',
  defaultUploadServer:
    process.env.VUE_APP_UPLOAD_SERVER || 'http://127.0.0.1:1080/files',
}
